import { render, staticRenderFns } from "./proposePro.vue?vue&type=template&id=5322dff8&scoped=true&"
import script from "./proposePro.vue?vue&type=script&lang=js&"
export * from "./proposePro.vue?vue&type=script&lang=js&"
import style0 from "./proposePro.vue?vue&type=style&index=0&id=5322dff8&scoped=true&lang=css&"
import style1 from "./proposePro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322dff8",
  null
  
)

export default component.exports